import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Menu,
  MenuItem,
  Typography,
  Badge,
} from "@mui/material";
import { Box, Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Link } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import i18next from "i18next";
import LanguageIcon from "@mui/icons-material/Language";
import Login from "../common/Login";
import { toast } from "react-hot-toast";
import SearchBarNew from "../Search/SearchBarNew";

const Header1 = ({ logo, cartTotal, languages }) => {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate data loading if needed
    if (languages) {
      setLoading(false);
    }
  }, [languages]);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const Nologin = () => {
    toast.error("Please Login!");
  };

  return (
    <Container sx={{ backgroundColor: 'rgba(235, 48, 15, 1)' }}>
      <div className="header-wrapper-sec desktop-header">
        <Grid container spacing={2}>
          <Grid item md={3} sx={{ order: { sm: 1 } }}>
            <Link to="/">
              <div className="logo-wrapper">
                {isLoading ? (
                  <img src={logo} alt="logo" />
                ) : (
                  <img src={logo} alt="logo" />
                )}
              </div>
            </Link>
          </Grid>
          <Grid
            item
            md={6}
            sx={{ margin: "auto", order: { sm: 3, md: 2 } }}
            className="hidden-search"
          >
            <Box
              sx={{
                "@media screen and (min-width: 62em)": {
                  transform: "translate(-24px, 0px)",
                },
              }}
            >
              <SearchBarNew />
            </Box>
          </Grid>
          <Grid
            item
            md={3}
            sx={{
              margin: "auto",
              order: { sm: 2, md: 3 },
              mr: { sm: -1, md: 0 },
            }}
          >
            <div className="menu-wrapper">
              <Box sx={{ display: { xs: "none", sm: "flex" } }}>
      

                {/* Login component */}
                <div className="login">
                  <Login />
                </div>

                
                  <Link to="/cart">
                    <Tooltip title="Cart">
                      <IconButton
                        size="large"
                        aria-label="show cart items"
                        color="inherit"
                      >
                        <Badge
                          badgeContent={cartTotal !== 0 ? cartTotal : null}
                          color="error"
                        >
                          <ShoppingCartIcon />
                        </Badge>
                      </IconButton>
                    </Tooltip>
                  </Link>
              

      

                <Box sx={{ flexGrow: 0, margin: "auto" }}>
                  <Tooltip title="Language">
                    <IconButton
                      className="share-btn"
                      onClick={handleOpenNavMenu}
                      sx={{ fontSize: "18px", color: "#000" }}
                    >
                      <LanguageIcon />
                    </IconButton>
                  </Tooltip>

                  <Menu
                    sx={{ mt: "45px" }}
                    id="menu-appbar"
                    anchorEl={anchorElNav}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    open={Boolean(anchorElNav)}
                    onClose={handleCloseNavMenu}
                  >
                    {languages &&
                      languages.map((lang, index) => {
                        const { country_code, code, language } = lang;
                        return (
                          <MenuItem
                            key={index}
                            onClick={handleCloseNavMenu}
                          >
                            <Typography
                              onClick={() => i18next.changeLanguage(code)}
                              className="lng-btn"
                            >
                              <span className="flag-icon">
                                <ReactCountryFlag
                                  style={{
                                    width: "1.5em",
                                    height: "1.5em",
                                    marginRight: "20px",
                                  }}
                                  countryCode={country_code}
                                  svg
                                  title={country_code}
                                />
                              </span>
                              {language}
                            </Typography>
                          </MenuItem>
                        );
                      })}
                  </Menu>
                </Box>
              </Box>
            </div>
          </Grid>
        </Grid>
      </div>
    </Container>
  );
};

export default Header1;
